import Swal from "sweetalert2";

export const SwalAlert = (icon, title, textoAlert) => {
  console.log(textoAlert);
  Swal.fire({
    icon: icon,
    title: title,
    text: textoAlert,
  });
};
